import { cva, type VariantProps } from 'class-variance-authority'
import type React from 'react'

import { cn } from '@/lib/cn'

const scaleVariants = cva(
  'flex justify-between gap-2 rounded-lg border px-3 py-2',
  {
    variants: {
      isError: {
        true: 'border-system-state-error',
        false: 'border-system-border-secondary',
      },
    },
    defaultVariants: {
      isError: false,
    },
  },
)
const Scale = ({
  className,
  isError,
  ...props
}: React.HTMLAttributes<HTMLUListElement> &
  VariantProps<typeof scaleVariants>) => (
  <ul className={cn(scaleVariants({ className, isError }))} {...props} />
)
Scale.displayName = 'Scale'

const scaleItemVariants = cva(
  'flex size-10 items-center justify-center rounded-md p-3 text-sm font-medium text-system-text-primary',
  {
    variants: {
      isSelected: {
        true: 'bg-system-grey-light',
        false: '',
      },
    },
    defaultVariants: {
      isSelected: false,
    },
  },
)
const ScaleItem = ({
  className,
  isSelected,
  ...props
}: React.LiHTMLAttributes<HTMLLIElement> &
  VariantProps<typeof scaleItemVariants>) => (
  <li className={cn(scaleItemVariants({ className, isSelected }))} {...props} />
)
ScaleItem.displayName = 'ScaleItem'

export { Scale, ScaleItem }
